<template>
  <div
    v-if="fromInfoData"
    class="from-module containerScroll"
    :class="{'en-form': isEnglish}"
  >
    <div
      v-if="receptionInfo.child && receptionInfo.child[0]"
      class="reception-info"
    >
      <div
        v-if="!isRecMethodEidt"
      >
        <not-can-edit-item
          :data="receptionInfoNew.child[0]"
          @handleEdit="recEditShow"
        />
      </div>
      <!-- 编辑接待方式form start-->
      <a-form
        v-if="isRecMethodEidt && receptionInfoNew.child[0].isedit"
        :form="form"
        layout="inline"
        @submit="handleSubmit"
      >
        <my-item
          v-show="receptionInfo.child[0].fieldtype"
          :id="receptionInfo.child[0].fieldkey"
          :ref="`item_${receptionInfo.child[0].fieldkey}`"
          class="clearfix"
          :data="receptionInfo.child[0]"
          :modules-data="fromInfoData"
          @change="handleChangeItem($event, receptionInfo.child[0])"
        />
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            :loading="isSubmiting"
          >
            {{ $t('message["915"]') }}
          </a-button>
          <a-button
            @click="handleReset"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 编辑接待方式form end-->
    </div>
    <div
      class="parent-from clearfix"
    >
      <not-can-edit-item :data="fromInfoData" />
      <!-- 修改按钮 -->
      <a
        v-if="fromInfoData.isedit"
        class="edit-btn fs-blue"
        @click="handleEdit"
      >{{ $t('message["1388"]') }}</a>
    </div>

    <!-- 信息来源部分特殊处理 start -->
    <template v-if="currentFrom">
      <not-can-edit-item
        v-for="(item) in fromInfoData.childObj && fromInfoData.childObj[currentFrom] && fromInfoData.childObj[currentFrom].child"
        :key="item.fieldkey"
        :data="item"
        :class="{hide: item.isshow !== 1}"
      />
    </template>
    <!-- 信息来源部分特殊处理 end -->
    <EditInfoFromModal :visible.sync="showModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NotCanEditItem from './../formItem/NotCanEdit'
import EditInfoFromModal from './modal/EditInfoFromModal'
import { cloneDeep } from 'lodash'
import { getLang } from '@/lib/storage'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import MyItem from './../formItem/Item'

export default {
  components: {
    NotCanEditItem,
    EditInfoFromModal,
    MyItem
  },
  mixins: [inquiryFormMixin],
  data () {
    return {
      currentFrom: '',
      fromInfoData: {},
      showModal: false,
      isRecMethodEidt: false,
      form: this.$form.createForm(this),
      tempReceptionInfo: {},
      isSubmiting: false
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', [
      'fromInfo',
      'receptionInfo'
    ]),
    isEnglish () {
      return this.getLang() === 'en'
    },
    inquiryid () {
      return this.$route.params.inquiryId || 0
    },
    receptionInfoNew () {
      const { receptionInfo = {} } = this
      const values = receptionInfo.child[0].fieldvalue
      let namesArr = []
      if (values.length > 0) {
        values.forEach(val => {
          this.filterName(namesArr, receptionInfo.child[0].options, val)
        })
      }
      receptionInfo.child[0].valuenames = namesArr
      return receptionInfo
    }

  },
  watch: {
    fromInfo: {
      handler (val) {
        this.fromInfoData = cloneDeep(val)
        const { fieldvalue = '', child = [], childObj = {} } = this.fromInfoData || {}
        let currentItem = child.find(one => one.fieldkey === fieldvalue) || {}
        this.currentFrom = currentItem.id
        this.fromInfoData.fieldvalue = this.currentFrom

        if (!this.currentFrom) {
          this.currentFrom = child[0] && child[0].id
        }

        this.fromInfoData.options = child.map(item => {
          return {
            id: item.id,
            name: item.fieldname
          }
        })

        this.fromInfoData.fieldname = this.fromInfoData.fromname

        for (let k in childObj) {
          const item = childObj[k]
          item.isedit = 0
        }
      },
      immediate: true,
      deep: true
    },
    // 编辑前复制一份值，取消的时候恢复原始值
    isRecMethodEidt (val) {
      if (val) {
        this.tempReceptionInfo = cloneDeep(this.receptionInfo)
      }
    }
  },
  methods: {
    getLang,
    ...mapActions('inquery/detailData', ['editReceptMethod']),
    handleChangeFrom (val) {
      this.currentFrom = val
    },
    handleEdit () {
      this.showModal = true
    },
    recEditShow () {
      this.isRecMethodEidt = true
    },
    // 编辑接待方式
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.isSubmiting = true
          console.log(values)
          const params = {
            inquiryid: this.inquiryid,
            'reception_info': values
          }
          const chain = await this.editReceptMethod(params)
          chain.onSuccess(raw => {
            this.isRecMethodEidt = false
          })
            .onNetSuccess(raw => {
              this.isSubmiting = false
            })
        }
      })
    },
    // 取消编辑
    handleReset () {
      this.receptionInfo.child[0] = this.tempReceptionInfo.child[0]
      this.isRecMethodEidt = false
    },
    // 处理接待显示的name值
    filterName (namesArr, arr, id) {
      arr.forEach(item => {
        if (item.id === id) {
          namesArr.push(item.name)
        } else {
          if (item.children && item.children.length > 0) {
            this.filterName(namesArr, item.children, id)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.reception-info::v-deep {
  padding-bottom: 12px;
  border-bottom: solid 1px #ebebeb;
  .ant-form {
    .ant-form-item-control-wrapper{
      padding-left: 0 !important;

    }
  }
  .ant-form-item{
    margin-bottom: 0;
  }
  .not-edit-item{
      margin-bottom: 0;
      .edit-btn {
        margin-left: 16px;
      }
  }
}
.from-module {
  padding: 30px 0 200px;
}
.parent-from {
  margin: 12px 0;
  .not-edit-item {
    float: left;
    margin-bottom: 0px;
  }
  .edit-btn {
    margin-left: 16px;
    line-height: 32px;
  }
}
.en-form::v-deep {
  .reception-info {
    .ant-form {
      .ant-form-item-label {
        width: 160px;
      }
      .ant-form-item:last-child, .ant-btn.ant-btn-default{
        margin-right: 0;
      }
      .ant-form-item-control-wrapper {
      padding-left: 160px;
    }
      .ant-form-item-label::after {
        left: 142px;
        top: 0;
        color: #666;
    }
    }
  }
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
